export default "__VITE_ASSET__Rv9WxH3H__"